function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.949 23.691a1.39 1.39 0 01-.988-.409 1.385 1.385 0 01-.41-.988c0-.374.146-.726.41-.99l2.475-2.475-2.097-2.097a.5.5 0 010-.707c.919-.919 2.14-1.425 3.439-1.425s2.521.506 3.439 1.425a4.87 4.87 0 010 6.879.5.5 0 01-.707 0l-2.098-2.098-2.475 2.476a1.384 1.384 0 01-.988.409zm.472-7.29l2.074 2.074a.5.5 0 010 .707l-2.828 2.829a.394.394 0 000 .562c.15.152.413.152.563 0l2.828-2.828a.514.514 0 01.707 0L7.84 21.82a3.87 3.87 0 00-.331-5.089c-1.339-1.337-3.611-1.47-5.088-.33z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.035 17.885a.5.5 0 01-.383-.821l9.413-11.213L7.19 15.58a.501.501 0 01-.666-.746L22.617.436a.5.5 0 01.716.695L9.418 17.706a.5.5 0 01-.383.179zM6.407 21.594a.502.502 0 01-.354-.146L2.795 18.19a.5.5 0 01.707-.707L6.76 20.74a.5.5 0 01-.353.854zM22.052 23.691c-.374 0-.726-.146-.989-.409l-2.476-2.476-2.097 2.098a.514.514 0 01-.707 0 4.87 4.87 0 010-6.879 4.831 4.831 0 013.439-1.425 4.83 4.83 0 013.439 1.425.5.5 0 010 .708l-2.098 2.097 2.476 2.476a1.4 1.4 0 010 1.978 1.389 1.389 0 01-.987.407zM18.587 19.6c.133 0 .26.053.354.146l2.829 2.829a.408.408 0 00.563 0 .399.399 0 000-.563l-2.829-2.829a.5.5 0 010-.708l2.075-2.074c-1.478-1.141-3.75-1.008-5.089.331a3.87 3.87 0 00-.331 5.089l2.074-2.075a.503.503 0 01.354-.146z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.594 21.594a.5.5 0 01-.354-.853l3.258-3.258a.5.5 0 01.707.707l-3.258 3.258a.498.498 0 01-.353.146zM17.143 15.707a.498.498 0 01-.333-.127l-3.586-3.209a.5.5 0 01.666-.746l3.586 3.209a.5.5 0 01-.333.873zM10.441 12.496a.498.498 0 01-.383-.179L.668 1.13a.5.5 0 01.716-.695l10.887 9.74a.5.5 0 01-.666.746L5.933 5.849l4.891 5.826a.499.499 0 01-.383.821zM14.965 17.885a.498.498 0 01-.383-.179l-2.964-3.53a.499.499 0 01.062-.704.496.496 0 01.704.062l2.964 3.53a.499.499 0 01-.383.821z"
});

var SvgGames = function SvgGames(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 100,
    width: 100,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGames, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/games.403f9b75.svg";
export { ForwardRef as ReactComponent };